<nb-card>
  <nb-card-header>
    <fa-icon icon="close" (click)="exit($event)" class="exit-icon"></fa-icon>
    <h3>{{ commentTitle }}</h3>
  </nb-card-header>
  <nb-card-body>
    @if (comments.length) {
      <table class="table workflow-comments-table">
        @for (comment of comments; track comment) {
          <tr
            class="comment-item"
            >
            <td>{{ comment.workflow_round.name }}</td>
            <td>{{ comment.comment_by }}</td>
            <td>{{ comment.comment_on|date }}</td>
            <td  class="comments-col" [innerHTML]="safeCommentText(comment)"></td>
          </tr>
        }
      </table>
    }
  </nb-card-body>
</nb-card>
